import { render, staticRenderFns } from "./OrganismTheModal.vue?vue&type=template&id=3f520fa3"
import script from "./OrganismTheModal.vue?vue&type=script&lang=js"
export * from "./OrganismTheModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports